import { isUserEntity, stringifyEntityRef } from '@backstage/catalog-model';
import { useEntityRefLink } from '@backstage/plugin-catalog-react';
import { Avatar, Skeleton, Text } from '@backstage/ui';
import { Card, useGetEntitiesByRef } from '@ipen-portal/plugin-common-react';
import { Link } from 'react-router-dom';

import classes from './ResponsibleHomeCard.module.css';

const CONTACTS = [
  {
    entityRef: 'user:default/christian.opitz_enviam.de',
    name: 'Christian Opitz',
    role: 'Chief Product Owner',
  },
  {
    entityRef: 'user:default/dennis.brause_eon.com',
    name: 'Dennis Brause',
    role: 'Chief Solution Architect',
  },
];
const ENTITY_REFS = CONTACTS.map(contact => contact.entityRef);

export const ResponsibleHomeCard = () => {
  const entityRefLink = useEntityRefLink();
  const { data: userEntities, isError, isPending } = useGetEntitiesByRef(ENTITY_REFS, {
    predicate: isUserEntity,
  });

  return (
    <Card className={classes.root} title="Who is responsible for iPEN?">
      {isError
        ? <p role="alert">Contacts could not be loaded.</p>
        : (
            <div aria-busy={isPending} className={classes.contacts}>
              {CONTACTS.map(contact => {
                const userEntity = userEntities?.find(user => user && stringifyEntityRef(user) === contact.entityRef);

                return (
                  <div className={classes.contact} key={contact.entityRef}>
                    {isPending
                      ? <Skeleton height={40} width={40} />
                      : (
                          <Avatar
                            name={contact.name}
                            purpose="decoration"
                            size="large"
                            src={userEntity ? userEntity.spec.profile?.picture ?? '' : ''}
                          />
                        )}
                    <div className={classes.details}>
                      {userEntity
                        ? <Link className={classes.link} to={entityRefLink(userEntity)}>{contact.name}</Link>
                        : <Text as="p">{contact.name}</Text>}
                      <Text as="p" color="secondary" variant="body-small">{contact.role}</Text>
                      {!isPending && !userEntity && (
                        <Text as="p" color="secondary" variant="body-small">User not found in catalog.</Text>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
    </Card>
  );
};
